import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BasePackageCardDirective,
  PackageCardOption,
} from '../../shared/components/base-package-card.directive';

export type { PackageCardOption };

/**
 * Displays a package card view and provides stable trackBy helpers for rendering package-related collections efficiently.
 * @component
 * @selector app-package-card
 * @example
 *   <app-package-card [inputProp]="sample_value1" (outputEvent)="handler()"></app-package-card>
 * @input any inputProp - Inherited input properties from BasePackageCardDirective used to configure the package card.
 * @output any outputEvent - Inherited output events from BasePackageCardDirective used to notify parent components of package card interactions.
 * @method trackByIndex Returns the current array index for use with ngFor trackBy.
 * @method trackByValue Returns an item's value, or the item itself, for use with ngFor trackBy.
 * @method trackById Returns an item's id, or the item itself, for use with ngFor trackBy.
 * @method trackByString Returns the provided string/item for use with ngFor trackBy.
 * @lifecycle OnInit Inherits Angular lifecycle behavior from BasePackageCardDirective, if implemented there.
 * @lifecycle OnChanges Inherits Angular lifecycle behavior from BasePackageCardDirective, if implemented there.
 */
@Component({
  selector: 'app-package-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './package-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./package-card.component.scss'],
})
export class PackageCardComponent extends BasePackageCardDirective {
  trackByIndex(index: number): number {
    return index;
  }
  trackByValue(_: number, item: any): any {
    return item?.value ?? item;
  }
  trackById(_: number, item: any): any {
    return item?.id ?? item;
  }
  trackByString(_: number, s: any): any {
    return s;
  }
}
